/**
 * Адрес временной ссылки.
 *
 * Вынесен отдельно, потому что нужен в двух местах: при выдаче — чтобы
 * положить в буфер обмена, и в списке выданных — чтобы показать текстом.
 * Второе не роскошь: буфер обмена бывает закрыт (браузер отказал в правах,
 * соединение не защищено, iOS не считает нажатие жестом), и тогда показанный
 * текст остаётся единственным способом достать уже выданную ссылку.
 */

export function shareUrl(key: string, origin: string): string {
  return `${origin.replace(/\/+$/, '')}/s/${key}`
}
